import React, { useForm } from 'react'
import { Modal, Input, Form } from 'antd'
import RowLayout from './../../../commons/RowLayout/RowLayout'

const LayoutAddModal = ({ T, isOpen, onSubmit, onClose }) => {
    const [form] = Form.useForm()

    function onOk() {
        form.validateFields()
            .then(values => {
                onSubmit(values.name)
                form.resetFields()
            })
            .catch(err => {
                console.log('Validate Failed:', err)
            })
    }

    return (
        <Modal
            form={form}
            title={T('LAYOUT')}
            centered
            destroyOnClose
            visible={isOpen}
            okText={T('OK')}
            cancelText={T('CANCEL')}
            onOk={() => onOk()}
            onCancel={() => onClose()}>
            <Form form={form}>
                <RowLayout title={T('NAME')} contentSpan={16}>
                    <Form.Item
                        name="name"
                        rules={[
                            {
                                required: true,
                                message: T('FORM_ERR_REQUIRE')
                            }
                        ]}>
                        <Input />
                    </Form.Item>
                </RowLayout>
            </Form>
        </Modal>
    )
}

export default LayoutAddModal
